// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as FontSizes from "../theme/FontSizes.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {};
function styleProps(tone, italic, bold, size) {
  return Stylex.props(styles.Span_root, {
    color: tone === "faded" ? "#bdbdca" : tone === "success" ? "#1dbb7a" : "#fefefe",
    fontSize: FontSizes.toPx(size),
    fontStyle: italic ? "italic" : "normal",
    fontWeight: bold ? 700 : 400
  });
}
let make = React.memo(props => {
  let __size = props.size;
  let __bold = props.bold;
  let __italic = props.italic;
  let __tone = props.tone;
  let tone = __tone !== undefined ? __tone : "neutral";
  let italic = __italic !== undefined ? __italic : false;
  let bold = __bold !== undefined ? __bold : false;
  let size = __size !== undefined ? __size : "xxsmall";
  let match = styleProps(tone, italic, bold, size);
  return JsxRuntime.jsx("span", {
    children: props.text,
    className: match.className,
    style: match.style
  });
});
let styles$1 = {
  Gap_root: {
    "borderStyle-ksu8eU": "borderStyle-xng3xce",
    "borderWidth-kMzoRj": "borderWidth-xc342km",
    "visibility-k33iCy": "visibility-xlshs6z",
    "margin-kogj98": "margin-x1ghz6dp",
    $$css: "wino-gc:src/resources/overlays/Tooltip.res.js:52"
  }
};
function styleProps$1(space) {
  return Stylex.props(styles$1.Gap_root, {
    paddingBottom: String(Spaces.toFloat(space)) + "px"
  });
}
let make$1 = React.memo(props => {
  let __space = props.space;
  let space = __space !== undefined ? __space : "none";
  let match = styleProps$1(space);
  return JsxRuntime.jsx("hr", {
    className: match.className,
    style: match.style
  });
});
let styles$2 = {
  Overlay_arrow: {
    "borderBottomColor-kL6WhQ": "borderBottomColor-x12d96pf",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-x1qhh985",
    "borderLeftColor-kaZRDh": "borderLeftColor-x1g4hjc",
    "borderLeftWidth-kZ1KPB": "borderLeftWidth-x1qbpyof",
    "borderRightColor-k26BEO": "borderRightColor-xhe5wa1",
    "borderRightWidth-kWqL5O": "borderRightWidth-x1fych4y",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderTopColor-kLZC3w": "borderTopColor-x1wpimy7",
    "borderTopWidth-kEafiO": "borderTopWidth-x1kr8tdy",
    "position-kVAEAm": "position-x10l6tqk",
    $$css: "wino-gc:src/resources/overlays/Tooltip.res.js:87"
  }
};
function arrowStyleProps(placement, positionStyleProps, crossOffset) {
  let tmp;
  let exit = 0;
  if (placement === "bottom") {
    let left = positionStyleProps.style.left;
    if (left !== undefined) {
      tmp = {
        left: String(left + crossOffset - 4) + "px",
        top: "-5px"
      };
    } else {
      exit = 1;
    }
  } else if (placement === "right") {
    let top = positionStyleProps.style.top;
    if (top !== undefined) {
      tmp = {
        left: "-7px",
        top: String(top + crossOffset - 3) + "px"
      };
    } else {
      exit = 1;
    }
  } else if (placement === "top") {
    let left$1 = positionStyleProps.style.left;
    if (left$1 !== undefined) {
      tmp = {
        bottom: "-5px",
        left: String(left$1 + crossOffset - 4) + "px"
      };
    } else {
      exit = 1;
    }
  } else {
    let top$1 = positionStyleProps.style.top;
    if (top$1 !== undefined) {
      tmp = {
        right: "-7px",
        top: String(top$1 + crossOffset - 3) + "px"
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = {};
  }
  return Stylex.props(styles$2.Overlay_arrow, {
    transform: placement === "bottom" ? "rotate(180deg)" : placement === "right" ? "rotate(90deg)" : placement === "top" ? "rotate(0deg)" : "rotate(-90deg)"
  }, tmp);
}
let make$2 = React.memo(props => {
  let state = props.state;
  let __crossOffset = props.crossOffset;
  let offset = props.offset;
  let __arrowed = props.arrowed;
  let arrowed = __arrowed !== undefined ? __arrowed : true;
  let crossOffset = __crossOffset !== undefined ? __crossOffset : 0;
  let domRef = React.useRef(null);
  let props$1 = ReactAria.mergeProps(props.ariaProps, {
    isOpen: state.isOpen
  });
  let match = ReactAria.useTooltip(props$1, state);
  let tooltipProps = match.tooltipProps;
  let position = ReactAria.useOverlayPosition({
    targetRef: props.triggerDomRef,
    overlayRef: domRef,
    isOpen: state.isOpen,
    placement: props.placement,
    offset: arrowed ? Spaces.small + Stdlib_Option.getOr(offset, 0) : offset !== undefined ? offset : Spaces.xxsmall,
    crossOffset: crossOffset
  });
  let match$1 = {
    className: "color-x19co3pv lineHeight-x1xxsxie backgroundColor-xiij6z1 borderRadius-x1sxf85j display-x1rg5ohu maxWidth-x1dc814f padding-x153ncpu paddingBottom-xdvlbce",
    "data-style-src": "wino-gc:src/resources/overlays/Tooltip.res.js:77"
  };
  let match$2 = arrowStyleProps(position.placement, position.arrowProps, crossOffset);
  let tooltipProps$1 = props.immediateClose ? ReactAria.mergeProps(tooltipProps, {
    onMouseEnter: null,
    onTouchStart: null,
    onClick: event => {
      event.stopPropagation();
    }
  }) : ReactAria.mergeProps(tooltipProps, {
    onClick: event => {
      event.stopPropagation();
    }
  });
  let props$2 = ReactAria.mergeProps(tooltipProps$1, position.overlayProps);
  let newrecord = {
    ...props$2
  };
  return JsxRuntime.jsx(ReactAria.Overlay, {
    children: JsxRuntime.jsx("span", (newrecord.ref = Primitive_option.some(domRef), newrecord.children = JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [arrowed ? JsxRuntime.jsx("div", {
          className: match$2.className,
          style: match$2.style
        }) : null, JsxRuntime.jsx("div", {
          children: props.content,
          className: match$1.className,
          style: match$1.style
        })]
      }),
      displayed: state.isOpen,
      duration: 50
    }), newrecord))
  });
});
function Tooltip(props) {
  let altTriggerRef = props.altTriggerRef;
  let __triggerAlign = props.triggerAlign;
  let __triggerCursor = props.triggerCursor;
  let __closeDelay = props.closeDelay;
  let __delay = props.delay;
  let __grow = props.grow;
  let __disabled = props.disabled;
  let __placement = props.placement;
  let __arrowed = props.arrowed;
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let arrowed = __arrowed !== undefined ? __arrowed : true;
  let placement = __placement !== undefined ? __placement : "bottom";
  let disabled = __disabled !== undefined ? __disabled : false;
  let grow = __grow !== undefined ? __grow : false;
  let delay = __delay !== undefined ? __delay : 500;
  let closeDelay = __closeDelay !== undefined ? __closeDelay : 50;
  let triggerCursor = __triggerCursor !== undefined ? __triggerCursor : "help";
  let triggerAlign = __triggerAlign !== undefined ? __triggerAlign : "auto";
  let domRef = React.useRef(null);
  let props_isDisabled = disabled;
  let props_isOpen = props.opened;
  let props_delay = delay;
  let props_closeDelay = closeDelay;
  let props_onOpenChange = props.onOpenChange;
  let props$1 = {
    isDisabled: props_isDisabled,
    isOpen: props_isOpen,
    delay: props_delay,
    closeDelay: props_closeDelay,
    onOpenChange: props_onOpenChange
  };
  let state = ReactStately.useTooltipTriggerState(props$1);
  let match = ReactAria.useTooltipTrigger(props$1, state, domRef);
  let onRequestClose = state.close;
  let onRequestOpen = state.open;
  React.useEffect(() => {
    let domElement = Stdlib_Option.flatMap(altTriggerRef, ReactDomElement.fromRef);
    if (domElement === undefined) {
      return;
    }
    let domElement$1 = Primitive_option.valFromOption(domElement);
    let onMouseEnter = _evt => onRequestOpen(false);
    let onMouseLeave = _evt => onRequestClose(false);
    domElement$1.addEventListener("mouseenter", onMouseEnter);
    domElement$1.addEventListener("mouseleave", onMouseLeave);
    return () => {
      domElement$1.removeEventListener("mouseenter", onMouseEnter);
      domElement$1.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [altTriggerRef, onRequestOpen, onRequestClose]);
  let opened = state.isOpen && !disabled;
  let triggerStyle = {
    cursor: disabled || delay <= 350 ? "inherit" : triggerCursor,
    display: "flex",
    alignSelf: triggerAlign,
    flexBasis: grow ? "0" : "auto",
    flexDirection: "column",
    flexGrow: grow ? "1" : "0"
  };
  let triggerProps = ReactAria.mergeProps(match.triggerProps, {
    onPointerDown: null,
    onMouseDown: null,
    tabIndex: null
  });
  let newrecord = {
    ...{
      className: "display-xjp7ctv position-x1n2onr6",
      "data-style-src": "wino-gc:src/resources/overlays/Tooltip.res.js:217"
    }
  };
  let newrecord$1 = {
    ...triggerProps
  };
  newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.style = triggerStyle, newrecord$1.ref = Primitive_option.some(domRef), newrecord$1.children = children, newrecord$1)), opened ? JsxRuntime.jsx(make$2, {
    arrowed: arrowed,
    placement: placement,
    offset: props.offset,
    crossOffset: props.crossOffset,
    content: props.content,
    state: state,
    ariaProps: match.tooltipProps,
    triggerDomRef: domRef,
    immediateClose: closeDelay < 50
  }) : null];
  return JsxRuntime.jsxs("div", newrecord);
}
let make$3 = React.memo(Tooltip);
let Span = {
  make: make
};
let Gap = {
  make: make$1
};
export { Span, Gap, make$3 as make };
/* styles Not a pure module */